import { render, staticRenderFns } from "./choydarCalculation.vue?vue&type=template&id=0c1508c4&scoped=true&"
import script from "./choydarCalculation.vue?vue&type=script&lang=js&"
export * from "./choydarCalculation.vue?vue&type=script&lang=js&"
import style0 from "./choydarCalculation.vue?vue&type=style&index=0&id=0c1508c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1508c4",
  null
  
)

export default component.exports